// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, xScreen } from "@werner/XDL/Utilities";
import styled, { css } from "styled-components";

export const GeneralLinksWrapper = styled.div`
    max-width: 200px;
    min-width: 180px;

    ${xScreen("lte", "md")} {
        min-width: unset;
        &&&& {
            max-width: none;
            margin-bottom: 20px;
            width: calc(100% - 12px);
            :has(dl) {
                width: 100%;
                margin-bottom: 0;
                margin-left: 16px;
                margin-right: -16px;
            }
        }
    }
    .list-wrapper {
        padding: 0;
        .title-wrapper .list-title {
            margin-bottom: 12px;
        }
        .title-wrapper .list-title > span {
            color: ${color("text.main")};
            font-size: 15px;
            line-height: 30px;
            letter-spacing: 0.5px;
            text-transform: capitalize;
        }
        .links-wrapper {
            margin-bottom: 10px;
            padding: 0;
            ${xScreen("lte", "md")} {
                padding-right: 0;
                margin-bottom: 0;
            }
            .list-link {
                ${xScreen("lte", "sm")} {
                    margin-bottom: 15px;
                    padding: 0 32px;
                }
                > span {
                    color: ${color("common.ui3")};
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 18px;
                    text-transform: capitalize;
                }
                &:hover > span {
                    text-decoration: underline;
                }
            }
        }
    }
`;
